import { render } from "./CalendarEventView.vue?vue&type=template&id=a1e741ce&scoped=true"
import script from "./CalendarEventView.vue?vue&type=script&lang=ts"
export * from "./CalendarEventView.vue?vue&type=script&lang=ts"

import "./CalendarEventView.vue?vue&type=style&index=0&id=a1e741ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a1e741ce"

export default script